import { GetterTree } from "vuex";
import { UserContextState, TenantSize } from "./types";
import { RootState } from "@/store/types";

export const getters: GetterTree<UserContextState, RootState> = {
	getTenantSize: state => {
		if (!state.isSet || !state.tenantOverview || !state.tenantOverview.areaCount || state.tenantOverview.areaCount < 1) {
			// user context not set, assume the worse case scenario
			return TenantSize.Large;
		}

		if (state.tenantOverview.areaCount < 100) {
			return TenantSize.Small;
		} else if (state.tenantOverview.areaCount < 500) {
			return TenantSize.Medium;
		} else {
			return TenantSize.Large;
		}
	}
};
